import {envVars} from '@/envVars'
import {StyledFinalText, StyledFooter, StyledLinkWrap, StyledSignUpLink} from './style'
import {useTranslation} from 'react-i18next'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const FooterSection = () => {
    const {t} = useTranslation()
    const sunproSiteUrl = envVars.VITE_ARYA_GROUP_URL ?? ''

    return (
        <Flexbox justify="center" direction="column" align="center" gap={4}>
            <StyledFinalText>
                <p>{t('quote:operation_system:final_text')}</p>
            </StyledFinalText>
            <StyledFooter justify="center">
                <StyledLinkWrap>
                    Arya Group S.p.A - Website: Arya Group S.p.A - Website:
                    <StyledSignUpLink target="_blank" to={sunproSiteUrl}>
                        aryagroupspa.com
                    </StyledSignUpLink>
                </StyledLinkWrap>
            </StyledFooter>
        </Flexbox>
    )
}

FooterSection.displayName = 'FooterSection'
